<template>
    <div>
        <el-form class="topForm" ref="form" :model="form" status-icon :rules="rules" label-width="100px" label-position="top">
            <el-container
                style="
                    border-radius: 15px;
                    padding: 0 0 0 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    justify-content: space-between;
                "
            >
                <!-- <el-main style="padding: 0 0 0 0;display:flex;justify-content:space-between;align-items:center"> -->
                <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        background: #fff;
                        border-radius: 8px;
                        padding: 10px 10px 20px 10px;
                        flex: 5;
                        height: 70px;
                    "
                >
                    <el-form-item label="格式:" prop="tabPosition" style="margin-right: 10px">
                        <el-radio-group v-model="form.typ" style="display: flex" @change="handleSearch">
                            <el-radio-button label="cust">按客户</el-radio-button>
                            <el-radio-button label="box">按柜台</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="日期:" prop="tabPosition">
                        <el-radio-group v-model="tabPosition" @change="handleClick" style="display: flex">
                            <el-radio-button label="today">今日</el-radio-button>
                            <el-radio-button label="zuori">昨日</el-radio-button>
                            <el-radio-button label="benyue">本月</el-radio-button>
                            <el-radio-button label="shangyue">上月</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="开始日期">
                        <!-- <label slot="label" style="padding: 0px 0px 0px 0px !important;">&emsp;</label> -->
                        <el-date-picker
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            v-model="form.begin_date"
                            style="width: 100%"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期">
                        <!-- <label slot="label" style="padding: 0px 0px 0px 0px !important;">&emsp;</label> -->
                        <el-date-picker
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            v-model="form.end_date"
                            style="width: 100%"
                        ></el-date-picker>
                    </el-form-item>
                </div>
                <div
                    style="
                        display: flex;
                        background: #fff;
                        border-radius: 8px;
                        padding: 10px 10px 20px 10px;
                        width: 20%;
                        height: 70px;
                        flex: 2;
                        margin-left: 1%;
                    "
                >
                    <el-form-item :label="$t('common.customer') + '：'" style="width: 100%">
                        <el-select
                            v-model="form.cust_no"
                            clearable
                            filterable
                            @change="refreshs()"
                            placeholder="请选择"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="(item, index) in pull_counter.custs"
                                :key="index"
                                :label="item.kind_name"
                                :value="item.kind_no"
                            >
                                <span style="margin-left: 10px">{{ item.kind_name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <!-- <div
                    style="display:flex;background: #fff;border-radius: 8px;padding: 10px 10px 20px 10px;width:20%;height:70px;flex:2;margin-left:1%"
                >
                    <el-form-item label="单据类型:" style="width: 100%">
                        <el-select
                            v-model="form.counter_no"
                            clearable
                            filterable
                            @change="refreshs()"
                            placeholder="请选择"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="(item, index) in pull_counter.counters"
                                :key="index"
                                :label="item.kind_name"
                                :value="item.kind_no"
                            >
                                <span style="margin-left: 10px">{{ item.kind_name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div> -->

                <div style="display: flex; height: 80px; flex: 1; margin-left: 1%">
                    <el-button @click="Clear()">&emsp;清空&emsp;</el-button>
                    <el-button type="primary" @click="handleSearch()">&emsp;{{ $t('common.search') }}&emsp;</el-button>
                    <!-- <el-button type="primary" @click="printContext" v-if="perData.allow_print == 1">{{ $t('common.print') }}</el-button> -->
                    <!-- <el-button style="margin-right: 10px" type="primary" @click="toImg" v-if="perData.allow_print == 1"
                            >转图片下载</el-button
                        > -->

                    <el-button type="primary" @click="outExcel">&emsp;{{ $t('common.export') }}&emsp;</el-button>
                </div>
                <!-- </el-main> -->
            </el-container>
        </el-form>
        <div>
            <div style="display: flex; margin-top: 10px">
                <div style="background: white; padding: 10px 10px 10px 10px; flex: 4; border-radius: 8px">
                    <p style="font-size: 14px">明细</p>
                    <template>
                        <div class="selectTableBox">
                            <el-table
                                stripe
                                border
                                :data="dtlArr"
                                style="width: 100%; margin-top: 5px; font-size: 14px"
                                :summary-method="getSummaries"
                                show-summary
                            >
                                <template slot="empty">
                                    <div style="display: flex; justify-content: center; align-items: center; height: 500px">
                                        <img src="@/assets/img/dontHave.png" alt="" style="width: 250px; height: 250px" />
                                    </div>
                                </template>
                                <el-table-column type="index" label="序号" width="59"> </el-table-column>
                                <el-table-column prop="客户名称" label="客户名称" v-if="form.typ == 'cust'"> </el-table-column>
                                <el-table-column prop="柜台名称" label="柜台名称" v-else> </el-table-column>
                                <el-table-column prop="产品名称" label="产品名称"> </el-table-column>
                                <el-table-column prop="利润金额" label="利润金额"> </el-table-column>
                                <el-table-column prop="平均单价" label="平均单价"> </el-table-column>
                                <el-table-column prop="成本总额" label="成本总额"> </el-table-column>
                                <el-table-column prop="销售重量" label="销售重量"> </el-table-column>
                                <el-table-column prop="销售金额" label="销售金额"> </el-table-column>
                            </el-table>
                            <div class="pagination">
                                <el-pagination
                                    background
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :current-page="form.page"
                                    :page-size="form.page_size"
                                    :page-sizes="[10, 20, 30]"
                                    :total="pageTotal"
                                    @current-change="handlePageChange"
                                    @size-change="pageSizeChange"
                                ></el-pagination>
                            </div>
                        </div>
                    </template>

                    <!-- <template v-else>
                        <div class="selectTableBox" style="display:flex;justify-content:center;align-items:center;height:500px">
                            <img src="@/assets/img/dontHave.png" alt="" style="width:250px;height:250px" />
                        </div>
                    </template> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { apiprofitRepPull, apiCurrentPermisson, apiSystem, apiprofitRep, apiprofitCust } from '@/request/api';
import print from 'print-js';
import html2canvas from 'html2canvas';
import $ from 'jquery';
export default {
    name: 'inSale',
    data: function () {
        return {
            tableData: [
                {
                    counter_name: '-',
                    style_name: '-',
                    cust_name: '-',
                    qty: '-',
                    wgt: '-'
                }
            ],
            pageTotal: 0,
            tabPosition: 'today',
            form: { begin_date: '', end_date: '', page: 1, page_size: 10, typ: 'cust' },

            allArr: '',
            pull_counter: '',
            rules: {
                begin_date: [{ required: true, message: '请选择起始日期', trigger: 'change' }],
                end_date: [{ required: true, message: '请选择结束日期', trigger: 'change' }]
            },
            dtlArr: [],
            showIndex: null,
            perData: '',
            systemSet: '',
            date1: '',
            date2: '',
            detailType: '格式一',
            pageLength: []
        };
    },
    created() {
        this.getPull();
        this.getPermission();
        this.getSystem();
        var d = new Date();
        var a = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        this.form.begin_date = a;
        this.form.end_date = a;
    },
    mounted() {},
    methods: {
        // //跳转
        handleDetails(row) {
            if (row.allow_use == '0') {
                this.$message.error('暂无权限');
            } else {
                if (row.bill_code) {
                    this.$router.push({
                        path: '/' + row.bill_code,
                        query: {
                            bill_no: row.bill_no
                        }
                    });
                }
            }
        },
        formatDate(date) {
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) {
                month = `0${month}`;
            }
            if (day < 10) {
                day = `0${day}`;
            }
            return `${year}-${month}-${day}`;
        },
        handleClick(tab) {
            if (tab == 'today') {
                this.form.begin_date = this.formatDate(new Date());
                this.form.end_date = this.formatDate(new Date());
            } else if (tab == 'zuori') {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth();
                const day = date.getDate();
                this.form.begin_date = this.formatDate(new Date(year, month, day - 1));
                this.form.end_date = this.formatDate(new Date(year, month, day - 1));
            } else if (tab == 'benyue') {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth();
                const thisMonthStartDate = this.formatDate(new Date(year, month, 1));
                // const thisMonthEndDate = this.formatDate(new Date(year, month + 1, 0));
                // 下个月第0天表示本月最后一天
                // const thisMonth = [];
                // thisMonth.push(thisMonthStartDate, thisMonthEndDate);
                this.form.begin_date = thisMonthStartDate;
                this.form.end_date = this.formatDate(new Date());
            } else if (tab == 'shangyue') {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth();
                const lastMonthStartDate = this.formatDate(new Date(year, month - 1, 1));
                const lastMonthEndDate = this.formatDate(new Date(year, month, 0));
                this.form.begin_date = lastMonthStartDate;
                this.form.end_date = lastMonthEndDate;
            }
            this.$forceUpdate();
        },
        outExcel() {
            var token = sessionStorage.getItem('userToken');
            if (this.form.typ == 'box') {
                this.$axios({
                    url: this.$baseURL + 'profit_rep_out',
                    method: 'post',
                    data: {
                        login_staff: localStorage.getItem('ms_username'),
                        begin_date: this.form.begin_date,
                        end_date: this.form.end_date,
                        cust_no: this.form.cust_no,
                        typ: this.form.typ,
                        is_redis: '1'
                    },
                    responseType: 'arraybuffer'
                }).then((res) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([res.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '销售利润表.xlsx';
                    link.click();
                });
            } else {
                this.$axios({
                    url: this.$baseURL + 'profit_rep_outs',
                    method: 'post',
                    data: {
                        login_staff: localStorage.getItem('ms_username'),
                        begin_date: this.form.begin_date,
                        end_date: this.form.end_date,
                        cust_no: this.form.cust_no,
                        typ: this.form.typ
                    },
                    responseType: 'arraybuffer'
                }).then((res) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([res.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '销售利润表.xlsx';
                    link.click();
                });
            }
        },
        //自定义合计行
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                switch (
                    column.property // column.property可以匹配它的每一列的命名， 然后赋值
                ) {
                    case '销售重量': //列名
                        //  if (column.property !== undefined) {
                        //加了prop属性的el-table-column 才能找到column.property
                        const wgt = data.map((item) => Number(item[column.property]));
                        if (!wgt.every((value) => isNaN(value))) {
                            sums[index] = wgt.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr; //多行相加
                                } else {
                                    return prev;
                                }
                            }, 0);
                        } else {
                            sums[index] = '';
                        }
                        if (sums[index]) {
                            sums[index] = sums[index].toFixed(this.pageLength.wgt); //保留2位小数
                        }
                        //  }
                        break;

                    default:
                        const amt = data.map((item) => Number(item[column.property]));
                        if (!amt.every((value) => isNaN(value))) {
                            sums[index] = amt.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr; //多行相加
                                } else {
                                    return prev;
                                }
                            }, 0);
                        } else {
                            sums[index] = '';
                        }

                        if (sums[index]) {
                            sums[index] = sums[index].toFixed(this.pageLength.amt); //重量wgt 金额价格amt 数量qty 折扣rate 小数长度
                        }
                        break;
                }
            });

            return sums;
        },

        getPull() {
            apiprofitRepPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.pull_counter = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        Clear() {
            this.form = {};
        },
        handleSearch() {
            this.form.page = 1;
            this.form.page_size = 10;
            // this.form.is_redis = 2;
            this.getList();
        },
        getList() {
            this.dtlArr = [];
            if (!this.form.end_date && !this.form.begin_date) {
                this.$message.error('请选择日期');
                return;
            }
            this.$load.show();
            if (this.form.typ == 'box') {
                apiprofitRep(this.form).then((res) => {
                    this.$load.close();
                    if (res.code == 2000) {
                        this.dtlArr = res.data.dtl;
                        this.date1 = res.data.begin_date;
                        this.date2 = res.data.end_date;
                        this.pageTotal = res.data.count;
                        this.pageLength = res.data.parms;
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            } else {
                apiprofitCust({
                    page: this.form.page,
                    page_size: this.form.page_size,
                    begin_date: this.form.begin_date,
                    end_date: this.form.end_date,
                    cust_no: this.form.cust_no
                }).then((res) => {
                    this.$load.close();
                    console.log(res);
                    if (res.code == 2000) {
                        this.dtlArr = res.data.data;
                        this.date1 = res.data.begin_date;
                        this.date2 = res.data.end_date;
                        this.pageTotal = res.data.count;
                        this.pageLength = res.data.parms;
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
        },
        // 下拉框出现和隐藏时
        myClear() {
            this.pull_cust = this.allArr.cust;
        },
        searchCounter(val) {
            this.form.bank_no = val;
            if (val) {
                var len = this.allArr.counter;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    if (len[i].kind_no.toLowerCase().indexOf(val.toLowerCase()) >= 0 || len[i].kind_name.indexOf(val) >= 0) {
                        arr.push(len[i]);
                    }
                }
                this.pull_counter = arr;
            } else {
                this.pull_counter = this.allArr.counter;
            }
        },
        refreshs() {
            this.$forceUpdate();
        },
        showDetails(e) {
            document.getElementById(e).scrollIntoView({
                behavior: 'smooth', // 平滑过渡
                block: 'start' // 上边框与视窗顶部平齐。默认值
            });
        },
        toImg() {
            html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then((canvas) => {
                // let url = canvas.toDataURL('image/jpeg', 1.0)
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
                //     printJS({
                //         printable: url,
                //         type: 'image',
                //         documentTitle: '打印图片'
                //     })
            });
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile('进销存表.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);

            // aLink.dispatchEvent(evt);
            //aLink.click()
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        printContext() {
            this.$print(this.$refs.print);
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '129'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.form.page = val;
            // this.form.is_redis = 1;
            this.getList();
        },
        pageSizeChange(val) {
            //
            this.form.page = 1;
            this.form.page_size = val;
            // this.form.is_redis = 1;
            this.getList();
        }
    }
};
</script>

<style scoped lang="scss">
.selectTableBox {
    // margin: 20px;
    // 合计行样式
    /deep/ .has-gutter tr td .cell:empty::before {
        // content: '';
    }
    /deep/ .el-table__footer-wrapper tbody td,
    .el-table__header-wrapper tbody td {
        // background-color: #e3f3ff !important;
    }
    /deep/ .el-table__footer-wrapper .is-leaf {
        // background-color: #e3f3ff !important;
    }
    /deep/ .el-table__fixed-footer-wrapper tbody td {
        // border-top: 1px solid #ebeef5;
        // background-color: #e3f3ff;
        // font-weight: bold;
        color: #f50b0b;
        // text-align: center !important;
    }
    /deep/ .has-gutter tr td .cell {
        // text-align: center;
        font-weight: bold;
        color: #f50b0b;
    }

    /deep/ .el-table {
        display: flex;
        flex-direction: column;
    }

    /* order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 */
    /deep/ .el-table__body-wrapper {
        // order: 0;
    }

    // 若没有固定列，以下代码可以不写
    // 将固定列放在首行
    /deep/ .el-table__fixed-body-wrapper {
        // top: 96px !important; // 根据自己的项目进行微调
    }

    /deep/ .el-table__fixed-footer-wrapper {
        font-weight: bold;
        // z-index: 0;
        // top: 48px; // 根据自己的项目进行微调
    }
}
.insale table {
    width: 100%;
    border-collapse: collapse;
    border: none;
}
.insale table td,
.insale table th {
    border: 1px solid rgb(138, 136, 136);
    padding: 5px 0;
    font-size: 12px;
}
.insale table th {
    font-weight: normal;
    color: #000;
    background: lightblue;
}
.insaleSlide {
    background: rgb(222, 253, 253);
    max-height: 700px; /*overflow-y: scroll;*/
    width: 10%;
    margin-top: 9px;
    margin-right: 10px;
}
.insaleSlide span {
    display: block;
    padding: 10px;
    font-size: 14px;
}
.minstablearr {
    display: flex;
}
.mintable {
    width: 25%;
    margin-right: 5px;
}
.totalparyt {
    display: flex;
    align-items: flex-start;
    width: 100%;
}
.insaleright {
    width: 90%;
    border: 1px solid rgb(228, 235, 236);
    padding: 10px 0;
}
.company {
    text-align: center;
    font-size: 16px;
    color: rgb(7, 16, 114);
    font-weight: bold;
    letter-spacing: 5px;
}
@media screen and (max-width: 768px) {
    .mintable {
        width: 100%;
    }
    .minstablearr {
        display: inline;
    }
    .totalparyt {
        display: inline;
    }
    .insaleSlide {
        width: 100%;
        margin-top: 0;
        margin-right: 0;
    }
    .insaleright {
        width: 100%;
    }
}
@media print {
    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
    }
}
</style>
